<template lang="pug">
.content.legacy-container(:class="{ 'has-nav': legacyNav.title }" v-if="isEmbedded || !featureFlags.legacyViewDisabled")
  ed-title-nav(:title='$t($route.query["back-to"])' v-if='$route.query["back-to"]')
    span(slot='action')
      router-link(:to='backTo')
        i.fa.fa-long-arrow-left
        span &nbsp; {{ $t('Back') + ' ' + $t('to') + ' ' + $t($route.query['back-to']) }}
  ed-title-nav(:fixed='false' v-if='legacyNav.title' :title='$t(legacyNav.title)' :subtitle='$t(legacyNav.subtitle)')
  div(ref='dialogContainer')
    a(href='#' @click.prevent='openNewFormatDialog' id='opendialog_hidden')

  #iframe.content(:class='iframeLoading')
    iframe(id="MainPageFrame" name="NetFrame", height="100%", width="100%", frameborder="0", scrolling="auto", :src="getModule()", @load='updateHash' :key='getModule(true)')
</template>

<script>
import featureFlags from '@/core/feature-flags/feature-flags'
// import { routeOldLinks } from './routeOldLinks'
import qs from 'qs'
import LegacyAuth from '@/core/legacy-auth'
import legacyRouter from '@/components/LegacyContainer/legacyRouter'
import { EventBus } from '@/event-bus'
import env from '@/core/api/env.json'
import supplierDialog from '../_modules/I2P/dialogs/InviteSupplierDialog'

import Vue from 'vue'
const eventHub = new Vue()

const { allowedComponents, allowedModules } = LegacyAuth

/** Allow for iframe interoperation */
if (document.domain) {
  const host = document.createElement('a')
  // host.href = global.location.protocol === 'https:' ? process.env.BASE || process.env.NET_GATEWAY : window.location.href
  host.href = process.env.BASE
  try {
    document.domain = host.hostname
  } catch (e) {}

  // resize iframe with content size
  global.addEventListener('message', event => {
    const d = qs.parse(event.data)
    const frame = global.document.getElementById('MainPageFrame')

    if (frame) {
      frame.style.height = parseInt(d.if_height) + 0 + 'px'
      // frame.style.width = d.if_width + 'px'
    }

    if (d.showOverlay === 'true') {
      document.body.setAttribute('legacy-modal', true)
      document.querySelector('.dawn-title-nav.sticky') && document.querySelector('.dawn-title-nav.sticky').classList.remove('sticky')
    }
    if (d.showOverlay === 'false') {
      document.body.setAttribute('legacy-modal', false)
      // global.document.getElementById('MainPageFrame').className = 'fade in'
    }

    if (d.showAddSupplierDialog === 'true') {
      document.getElementById('opendialog_hidden').click()
    }

    // hook into navigating inside legacy component
    if (d.showWelcome) {
      // global.document.getElementById('MainPageFrame').className = 'fade out'
    }
  })
}

export default {
  beforeCreate() {
    legacyRouter.methods.polyfillParent.call(this)
  },

  created() {
    // show loading indicator
    this.iframeLoading = 'loading-back'

    // if (featureFlags.legacyViewDisabled) routeOldLinks.call(this, this.$route, this.getModule())
  },

  updated() {
    // show loading indicator
    this.iframeLoading = 'loading-back'

    // force show loading indicator on navigating between different modules
    if (global.document.getElementById('iframe')) global.document.getElementById('iframe').className = 'content loading-back'

    // TODO:
    // fade out when loading another legacy module
    // if (global.document.getElementById('MainPageFrame')) global.document.getElementById('MainPageFrame').className = 'fade out'

    // TODO:
    // wider legacy pages
    // if (global.document.getElementById('MainPageFrame')) global.document.getElementById('MainPageFrame').style.width = '1240px'
  },

  props: {
    url: String,
    absUrl: String
  },

  computed: {
    legacyNav() {
      let nav = {}
      const module = allowedModules()[this.$route.params.page]

      if (module) {
        nav.title = module.title
        nav.subtitle = module.subtitle
      }

      return nav
    }
  },

  data() {
    return {
      featureFlags,
      iframeLoading: 'loading-back',

      uri: global.location.protocol === 'https:'
            ? process.env.NET_PROXY && process.env.NET_PROXY.replace(/:[0-9]+\//, '/') + '/' ||
              this.api.env + '/'
            : process.env.NET_GATEWAY
              .replace(env._default, `${env._default}${process.env.LEGACY_SUBDOMAIN}`)
              .replace(/:[0-9]+\//, '/') + '/',

      module: this.$route.params.page,

      backTo: { name: '_allModules',
        params: {
          namespace: 'd',
          page: this.$route.params.page,
          section: this.$route.hash.substr(1)
        }
      },

      isEmbedded: global.self !== global.top
    }
  },

  methods: {
    updateHash() {
      // const vm = this
      // TODO:
      // get url when navigating inside legacy module
      //
      // var currentModule = window.frames['NetFrame'].location.href.replace(this.uri, '')

      // if (currentModule !== this.$route.params.page) {
        // window.location.hash = '/' + this.$route.params.namespace + '/' + currentModule
      // }

      // hook
      try {
        EventBus.$emit('navigated', global.frames['NetFrame'].location.href)
      } catch (e) {}

      setTimeout(() => {
        if (global.frames['NetFrame']) {
          // flag legacy pages
          global.frames['NetFrame'].document.body.className.replace(' vue', '')
          global.frames['NetFrame'].document.body.className += ' vue'
          global.frames['NetFrame'].document.documentElement.className = ' vue'

          // TODO:
          // wider legacy pages
          // global.document.getElementById('MainPageFrame').style.width = '100%'
          // global.frames['NetFrame'].document.body.style.width = '100%'

          global.app.$loading = false
        }
      }, 5)

      // Detect if any error is thrown by backend and go to 404
      // or issue another request to find out if the session expired
      try {
        global.document.getElementById('MainPageFrame').contentDocument.body.nodeName && null
      } catch (e) {
        global.document.getElementById('iframe').className = 'broken'

        // find out if session expired
        // this.api.get(global.document.getElementById('MainPageFrame').src)

        setTimeout(() => {
          // this.$router.push('/404')
          global.app.$notifications.removeAll()
          if (global.app.$user.sessionSettings) {
            global.app.$notifications.notify({
              type: 'plain',
              icon: 'exclamation-circle',
              message: 'Something went wrong' +
                        `<br><a class="btn btn-xs btn-actionbar" target="_blank" href="https://www.eved.com/contact-us/">Report this</a>` +
                        `<a class="btn btn-xs btn-actionbar" href=".">Go to Dashboard</a>`,
              timeout: 0,
              placement: { from: 'top', align: 'center' }
            })
          } else {
            global.app.$notifications.notify({
              type: 'plain',
              icon: 'exclamation-circle',
              message: 'Invalid session',
              timeout: 2000,
              placement: { from: 'top', align: 'center' },
              onClose() {
                global.app.$user.logout()
              }
            })
          }
        }, 1000)
      }
    },

    getModule(force) {
      if (this.absUrl) return `${this.absUrl}`
      if (this.url) return `${this.api.env}/${this.url}`
      if (this.$route.params.namespace === 'd') return

      if (!allowedModules.get[this.$route.params.page] && this.$route.params.page !== 'Admin') {
        this.$router.push('/404')
      }

      const components = allowedComponents[this.$route.params.page]
                          ? allowedComponents[this.$route.params.page].pack
                          : null

      let uglyUrl = this.$route.params.section ? this.$route.params.section.replace(/--/g, '/') : ''

      //
      if (this.refreshBack) {
        // global.frames['NetFrame'].location.href = this.uri + '/' + (this.$route.params.section || 'Dashboard')
        // this.refreshKey = +new Date()
        this.refreshBack = null
      }

      if (this.$route.params.action === '--') this.refreshBack = true

      let url = components
                ? Object.keys(components).filter(k => components[k].name === this.$route.params.section)[0]
                  ? Object.keys(components).filter(k => components[k].name === this.$route.params.section)[0]
                  : uglyUrl
                : this.$route.params.section
                 ? uglyUrl + (this.$route.params.action && this.$route.params.action !== '--' ? '/' + this.$route.params.action : '')
                  : this.$route.params.page

      // php pages
      url = url.replace('common.', '../?page=common.')
      url = url.replace('vendors.', '../?page=vendors.')

      let gotoUrl = this.$route.query.goto
      let decodedUrl = decodeURIComponent(url)

      return `${this.uri}${gotoUrl || decodedUrl}`
    },

    openNewFormatDialog() {
      var ComponentClass = Vue.extend(supplierDialog)
      var instance = new ComponentClass({
        propsData: {
          type: 'primary',
          model: null,
          invoiceId: this.getInvoiceId,
          eventHub: eventHub,
          operation: 'add'
        }
      })
      instance.$slots.default = []
      instance.$mount()
      this.$refs.dialogContainer.appendChild(instance.$el)
    }
  }
}
</script>

<style lang='scss'>
@import "~@/assets/sass/_variables.scss";

// Full page layouts
body.pp-cover-page .main-panel .module.content,
body.pp-cover .main-panel .module.content {
  &:not(.pp-menu) {
    margin-top: 5px;
    margin-bottom: 7.4rem;
  }
  #iframe.loading-back:after {
    top: 5px;
  }
  #iframe.loading-back #MainPageFrame {
    opacity: 1;
  }
}
body.pp-cover-page .main-panel .module.content {
  margin-top: 0;
}
body.pp-cover-page .dawn-meta-nav[class],
body.pp-cover .dawn-meta-nav[class] {
  display: none;
}

body.pp-new-header-detail,
body.pp-new-header-short,
body.pp-new-header,
body.pp-full-width {
  #MainPageFrame {
    width: 100% !important;
  }
  .module.legacy-container {
    padding: 0;
    margin-top: 124px;
  }
}

body.pp-no-menu {
  &:not(.pp-menu) {
    .module.legacy-container {
      margin-top: 85px;
    }
  }
}

body.pp-full-width.pp-sticky-listen {
  .module.content {
    //margin-top: 72px;
    padding-left: 0;
    padding-right: 0;
  }
  #MainPageFrame {
    //margin-left: 0;
    //margin-right: 0;
    width: 100% !important;
  }
  .sub-menus {
    //display: none;
  }
}

// Modals
body[legacy-modal="true"] #layout .wrapper .main-panel:after {
  background: #000;
  opacity: .65;
  z-index: 9999;
  content: '';
  position: fixed;
}

.main-panel > .content.legacy-container {
  //padding: 0;
}

//
#MainPageFrame {
  display: block;
  margin: 0 auto;
  //width: 1240px;
  width: 100% !important;
  @include theme {
  background: v(canvas);
  }

  z-index: 99999;
  position: relative;
}

#iframe.broken {
  text-align: center;
  #MainPageFrame {
    visibility: hidden;
  }
  &:before {
    display: block;
    position: absolute;
    top: 40%;
    left: 50%;
    margin-left: -25px;
    content: '';
    font: 50px 'Font Awesome 5 Regular';
    content: '\f071';
    animation: fa-ring 2s linear infinite;
  }
}

#iframe.loading-back {
  &:after {
    content: '';
    position: absolute;
    top: 150px;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
    @include theme {
    background: v(canvas);
    }
    z-index: 9999;
  }
}

.legacy-container {
  &.hide-title {
    overflow: hidden;
    #iframe.content {
      margin-top: -110px;
    }
  }

  &.loading {
    min-height: 5em;
    &:before {
      z-index: 100000;
    }
    &:after {
      background: none;
    }

    .loading-back {
      &:before {
        display: none;
      }
    }
  }
}


body.pp-cover .loading-back #MainPageFrame {
  //opacity: 1;
}

.loading-back {
  #MainPageFrame {
    //display: none;
    opacity: .55;
  }

  &:before {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -25px;
    margin-left: -25px;
    font: 50px 'Font Awesome 5 Regular';
    content: '\f1ce';
    z-index: 100001;
    animation: fa-spin 1s infinite linear;
    @include theme {
    color: v(primary-04);
    }
  }
  &:after {
    content: '';
    position: absolute;
    top: 150px;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
    //background: #fff;
    //opacity: .55;
    z-index: 100000;
  }
}

.main-panel.loading .loading-back {
  &:before {
    display: none;
  }
}

.content.content.legacy-container.has-nav {
  margin-top: 82px;
}

</style>



// WEBPACK FOOTER //
// src/components/LegacyContainer/index.vue